'use client';
import { WuiAlert as WuiAlertElement, defineCustomElement as defineWuiAlert } from "@jwplayer/wui-components/dist/components/wui-alert.js";
import { WuiAutocomplete as WuiAutocompleteElement, defineCustomElement as defineWuiAutocomplete } from "@jwplayer/wui-components/dist/components/wui-autocomplete.js";
import { WuiBadge as WuiBadgeElement, defineCustomElement as defineWuiBadge } from "@jwplayer/wui-components/dist/components/wui-badge.js";
import { WuiBanner as WuiBannerElement, defineCustomElement as defineWuiBanner } from "@jwplayer/wui-components/dist/components/wui-banner.js";
import { WuiBox as WuiBoxElement, defineCustomElement as defineWuiBox } from "@jwplayer/wui-components/dist/components/wui-box.js";
import { WuiBreadcrumbs as WuiBreadcrumbsElement, defineCustomElement as defineWuiBreadcrumbs } from "@jwplayer/wui-components/dist/components/wui-breadcrumbs.js";
import { WuiButton as WuiButtonElement, defineCustomElement as defineWuiButton } from "@jwplayer/wui-components/dist/components/wui-button.js";
import { WuiCheckInputGroup as WuiCheckInputGroupElement, defineCustomElement as defineWuiCheckInputGroup } from "@jwplayer/wui-components/dist/components/wui-check-input-group.js";
import { WuiCheckInputPanel as WuiCheckInputPanelElement, defineCustomElement as defineWuiCheckInputPanel } from "@jwplayer/wui-components/dist/components/wui-check-input-panel.js";
import { WuiCheckInput as WuiCheckInputElement, defineCustomElement as defineWuiCheckInput } from "@jwplayer/wui-components/dist/components/wui-check-input.js";
import { WuiCheckListInput as WuiCheckListInputElement, defineCustomElement as defineWuiCheckListInput } from "@jwplayer/wui-components/dist/components/wui-check-list-input.js";
import { WuiCloseButton as WuiCloseButtonElement, defineCustomElement as defineWuiCloseButton } from "@jwplayer/wui-components/dist/components/wui-close-button.js";
import { WuiCodeEditor as WuiCodeEditorElement, defineCustomElement as defineWuiCodeEditor } from "@jwplayer/wui-components/dist/components/wui-code-editor.js";
import { WuiCodeSnippet as WuiCodeSnippetElement, defineCustomElement as defineWuiCodeSnippet } from "@jwplayer/wui-components/dist/components/wui-code-snippet.js";
import { WuiColorInput as WuiColorInputElement, defineCustomElement as defineWuiColorInput } from "@jwplayer/wui-components/dist/components/wui-color-input.js";
import { WuiColumn as WuiColumnElement, defineCustomElement as defineWuiColumn } from "@jwplayer/wui-components/dist/components/wui-column.js";
import { WuiColumns as WuiColumnsElement, defineCustomElement as defineWuiColumns } from "@jwplayer/wui-components/dist/components/wui-columns.js";
import { WuiComponentFooter as WuiComponentFooterElement, defineCustomElement as defineWuiComponentFooter } from "@jwplayer/wui-components/dist/components/wui-component-footer.js";
import { WuiComponentHeader as WuiComponentHeaderElement, defineCustomElement as defineWuiComponentHeader } from "@jwplayer/wui-components/dist/components/wui-component-header.js";
import { WuiDateInputCalendar as WuiDateInputCalendarElement, defineCustomElement as defineWuiDateInputCalendar } from "@jwplayer/wui-components/dist/components/wui-date-input-calendar.js";
import { WuiDateInput as WuiDateInputElement, defineCustomElement as defineWuiDateInput } from "@jwplayer/wui-components/dist/components/wui-date-input.js";
import { WuiDateRangeInputWithPresets as WuiDateRangeInputWithPresetsElement, defineCustomElement as defineWuiDateRangeInputWithPresets } from "@jwplayer/wui-components/dist/components/wui-date-range-input-with-presets.js";
import { WuiDateRangeInput as WuiDateRangeInputElement, defineCustomElement as defineWuiDateRangeInput } from "@jwplayer/wui-components/dist/components/wui-date-range-input.js";
import { WuiDatetimeReadonly as WuiDatetimeReadonlyElement, defineCustomElement as defineWuiDatetimeReadonly } from "@jwplayer/wui-components/dist/components/wui-datetime-readonly.js";
import { WuiDivider as WuiDividerElement, defineCustomElement as defineWuiDivider } from "@jwplayer/wui-components/dist/components/wui-divider.js";
import { WuiDraggableListItem as WuiDraggableListItemElement, defineCustomElement as defineWuiDraggableListItem } from "@jwplayer/wui-components/dist/components/wui-draggable-list-item.js";
import { WuiDraggableList as WuiDraggableListElement, defineCustomElement as defineWuiDraggableList } from "@jwplayer/wui-components/dist/components/wui-draggable-list.js";
import { WuiDurationInput as WuiDurationInputElement, defineCustomElement as defineWuiDurationInput } from "@jwplayer/wui-components/dist/components/wui-duration-input.js";
import { WuiEmptyState as WuiEmptyStateElement, defineCustomElement as defineWuiEmptyState } from "@jwplayer/wui-components/dist/components/wui-empty-state.js";
import { WuiExpandableTile as WuiExpandableTileElement, defineCustomElement as defineWuiExpandableTile } from "@jwplayer/wui-components/dist/components/wui-expandable-tile.js";
import { WuiExpandableToggle as WuiExpandableToggleElement, defineCustomElement as defineWuiExpandableToggle } from "@jwplayer/wui-components/dist/components/wui-expandable-toggle.js";
import { WuiFont as WuiFontElement, defineCustomElement as defineWuiFont } from "@jwplayer/wui-components/dist/components/wui-font.js";
import { WuiFormField as WuiFormFieldElement, defineCustomElement as defineWuiFormField } from "@jwplayer/wui-components/dist/components/wui-form-field.js";
import { WuiGraphIcon as WuiGraphIconElement, defineCustomElement as defineWuiGraphIcon } from "@jwplayer/wui-components/dist/components/wui-graph-icon.js";
import { WuiHyperlink as WuiHyperlinkElement, defineCustomElement as defineWuiHyperlink } from "@jwplayer/wui-components/dist/components/wui-hyperlink.js";
import { WuiIcon as WuiIconElement, defineCustomElement as defineWuiIcon } from "@jwplayer/wui-components/dist/components/wui-icon.js";
import { WuiInfobox as WuiInfoboxElement, defineCustomElement as defineWuiInfobox } from "@jwplayer/wui-components/dist/components/wui-infobox.js";
import { WuiInputButton as WuiInputButtonElement, defineCustomElement as defineWuiInputButton } from "@jwplayer/wui-components/dist/components/wui-input-button.js";
import { WuiInputMenu as WuiInputMenuElement, defineCustomElement as defineWuiInputMenu } from "@jwplayer/wui-components/dist/components/wui-input-menu.js";
import { WuiInput as WuiInputElement, defineCustomElement as defineWuiInput } from "@jwplayer/wui-components/dist/components/wui-input.js";
import { WuiJwPlayerBaseInjectorContainer as WuiJwPlayerBaseInjectorContainerElement, defineCustomElement as defineWuiJwPlayerBaseInjectorContainer } from "@jwplayer/wui-components/dist/components/wui-jw-player-base-injector-container.js";
import { WuiJwPlayerBaseInjector as WuiJwPlayerBaseInjectorElement, defineCustomElement as defineWuiJwPlayerBaseInjector } from "@jwplayer/wui-components/dist/components/wui-jw-player-base-injector.js";
import { WuiJwPlayerBaseOverlay as WuiJwPlayerBaseOverlayElement, defineCustomElement as defineWuiJwPlayerBaseOverlay } from "@jwplayer/wui-components/dist/components/wui-jw-player-base-overlay.js";
import { WuiJwPlayerBase as WuiJwPlayerBaseElement, defineCustomElement as defineWuiJwPlayerBase } from "@jwplayer/wui-components/dist/components/wui-jw-player-base.js";
import { WuiLayout as WuiLayoutElement, defineCustomElement as defineWuiLayout } from "@jwplayer/wui-components/dist/components/wui-layout.js";
import { WuiListItemDivider as WuiListItemDividerElement, defineCustomElement as defineWuiListItemDivider } from "@jwplayer/wui-components/dist/components/wui-list-item-divider.js";
import { WuiListItemHeader as WuiListItemHeaderElement, defineCustomElement as defineWuiListItemHeader } from "@jwplayer/wui-components/dist/components/wui-list-item-header.js";
import { WuiListItemMeta as WuiListItemMetaElement, defineCustomElement as defineWuiListItemMeta } from "@jwplayer/wui-components/dist/components/wui-list-item-meta.js";
import { WuiListItem as WuiListItemElement, defineCustomElement as defineWuiListItem } from "@jwplayer/wui-components/dist/components/wui-list-item.js";
import { WuiList as WuiListElement, defineCustomElement as defineWuiList } from "@jwplayer/wui-components/dist/components/wui-list.js";
import { WuiLoader as WuiLoaderElement, defineCustomElement as defineWuiLoader } from "@jwplayer/wui-components/dist/components/wui-loader.js";
import { WuiLogo as WuiLogoElement, defineCustomElement as defineWuiLogo } from "@jwplayer/wui-components/dist/components/wui-logo.js";
import { WuiMainNav as WuiMainNavElement, defineCustomElement as defineWuiMainNav } from "@jwplayer/wui-components/dist/components/wui-main-nav.js";
import { WuiMenuPane as WuiMenuPaneElement, defineCustomElement as defineWuiMenuPane } from "@jwplayer/wui-components/dist/components/wui-menu-pane.js";
import { WuiModal as WuiModalElement, defineCustomElement as defineWuiModal } from "@jwplayer/wui-components/dist/components/wui-modal.js";
import { WuiMoreMenu as WuiMoreMenuElement, defineCustomElement as defineWuiMoreMenu } from "@jwplayer/wui-components/dist/components/wui-more-menu.js";
import { WuiMultiSelectInput as WuiMultiSelectInputElement, defineCustomElement as defineWuiMultiSelectInput } from "@jwplayer/wui-components/dist/components/wui-multi-select-input.js";
import { WuiPageContent as WuiPageContentElement, defineCustomElement as defineWuiPageContent } from "@jwplayer/wui-components/dist/components/wui-page-content.js";
import { WuiPageHeader as WuiPageHeaderElement, defineCustomElement as defineWuiPageHeader } from "@jwplayer/wui-components/dist/components/wui-page-header.js";
import { WuiPagination as WuiPaginationElement, defineCustomElement as defineWuiPagination } from "@jwplayer/wui-components/dist/components/wui-pagination.js";
import { WuiPersistentModal as WuiPersistentModalElement, defineCustomElement as defineWuiPersistentModal } from "@jwplayer/wui-components/dist/components/wui-persistent-modal.js";
import { WuiProgressBar as WuiProgressBarElement, defineCustomElement as defineWuiProgressBar } from "@jwplayer/wui-components/dist/components/wui-progress-bar.js";
import { WuiProvider as WuiProviderElement, defineCustomElement as defineWuiProvider } from "@jwplayer/wui-components/dist/components/wui-provider.js";
import { WuiRadioButton as WuiRadioButtonElement, defineCustomElement as defineWuiRadioButton } from "@jwplayer/wui-components/dist/components/wui-radio-button.js";
import { WuiRadioGroup as WuiRadioGroupElement, defineCustomElement as defineWuiRadioGroup } from "@jwplayer/wui-components/dist/components/wui-radio-group.js";
import { WuiScrollIndicator as WuiScrollIndicatorElement, defineCustomElement as defineWuiScrollIndicator } from "@jwplayer/wui-components/dist/components/wui-scroll-indicator.js";
import { WuiSearchInput as WuiSearchInputElement, defineCustomElement as defineWuiSearchInput } from "@jwplayer/wui-components/dist/components/wui-search-input.js";
import { WuiSelectInput as WuiSelectInputElement, defineCustomElement as defineWuiSelectInput } from "@jwplayer/wui-components/dist/components/wui-select-input.js";
import { WuiSkeletonLine as WuiSkeletonLineElement, defineCustomElement as defineWuiSkeletonLine } from "@jwplayer/wui-components/dist/components/wui-skeleton-line.js";
import { WuiSlideOut as WuiSlideOutElement, defineCustomElement as defineWuiSlideOut } from "@jwplayer/wui-components/dist/components/wui-slide-out.js";
import { WuiSortInput as WuiSortInputElement, defineCustomElement as defineWuiSortInput } from "@jwplayer/wui-components/dist/components/wui-sort-input.js";
import { WuiStatus as WuiStatusElement, defineCustomElement as defineWuiStatus } from "@jwplayer/wui-components/dist/components/wui-status.js";
import { WuiTab as WuiTabElement, defineCustomElement as defineWuiTab } from "@jwplayer/wui-components/dist/components/wui-tab.js";
import { WuiTableHeaderRow as WuiTableHeaderRowElement, defineCustomElement as defineWuiTableHeaderRow } from "@jwplayer/wui-components/dist/components/wui-table-header-row.js";
import { WuiTableHeader as WuiTableHeaderElement, defineCustomElement as defineWuiTableHeader } from "@jwplayer/wui-components/dist/components/wui-table-header.js";
import { WuiTablePageLengthInput as WuiTablePageLengthInputElement, defineCustomElement as defineWuiTablePageLengthInput } from "@jwplayer/wui-components/dist/components/wui-table-page-length-input.js";
import { WuiTablePageNumberInput as WuiTablePageNumberInputElement, defineCustomElement as defineWuiTablePageNumberInput } from "@jwplayer/wui-components/dist/components/wui-table-page-number-input.js";
import { WuiTableRow as WuiTableRowElement, defineCustomElement as defineWuiTableRow } from "@jwplayer/wui-components/dist/components/wui-table-row.js";
import { WuiTable as WuiTableElement, defineCustomElement as defineWuiTable } from "@jwplayer/wui-components/dist/components/wui-table.js";
import { WuiTabs as WuiTabsElement, defineCustomElement as defineWuiTabs } from "@jwplayer/wui-components/dist/components/wui-tabs.js";
import { WuiTagList as WuiTagListElement, defineCustomElement as defineWuiTagList } from "@jwplayer/wui-components/dist/components/wui-tag-list.js";
import { WuiTag as WuiTagElement, defineCustomElement as defineWuiTag } from "@jwplayer/wui-components/dist/components/wui-tag.js";
import { WuiTextarea as WuiTextareaElement, defineCustomElement as defineWuiTextarea } from "@jwplayer/wui-components/dist/components/wui-textarea.js";
import { WuiThemeSection as WuiThemeSectionElement, defineCustomElement as defineWuiThemeSection } from "@jwplayer/wui-components/dist/components/wui-theme-section.js";
import { WuiThumbnailGrid as WuiThumbnailGridElement, defineCustomElement as defineWuiThumbnailGrid } from "@jwplayer/wui-components/dist/components/wui-thumbnail-grid.js";
import { WuiThumbnail as WuiThumbnailElement, defineCustomElement as defineWuiThumbnail } from "@jwplayer/wui-components/dist/components/wui-thumbnail.js";
import { WuiTileTabbedHeader as WuiTileTabbedHeaderElement, defineCustomElement as defineWuiTileTabbedHeader } from "@jwplayer/wui-components/dist/components/wui-tile-tabbed-header.js";
import { WuiTileTextHeader as WuiTileTextHeaderElement, defineCustomElement as defineWuiTileTextHeader } from "@jwplayer/wui-components/dist/components/wui-tile-text-header.js";
import { WuiTile as WuiTileElement, defineCustomElement as defineWuiTile } from "@jwplayer/wui-components/dist/components/wui-tile.js";
import { WuiToast as WuiToastElement, defineCustomElement as defineWuiToast } from "@jwplayer/wui-components/dist/components/wui-toast.js";
import { WuiToggle as WuiToggleElement, defineCustomElement as defineWuiToggle } from "@jwplayer/wui-components/dist/components/wui-toggle.js";
import { WuiTooltipLabel as WuiTooltipLabelElement, defineCustomElement as defineWuiTooltipLabel } from "@jwplayer/wui-components/dist/components/wui-tooltip-label.js";
import { WuiTooltip as WuiTooltipElement, defineCustomElement as defineWuiTooltip } from "@jwplayer/wui-components/dist/components/wui-tooltip.js";
import { WuiTopNav as WuiTopNavElement, defineCustomElement as defineWuiTopNav } from "@jwplayer/wui-components/dist/components/wui-top-nav.js";
import { createComponent } from '@stencil/react-output-target/runtime';
import React from 'react';
export const WuiAlert = /*@__PURE__*/ createComponent({
    tagName: 'wui-alert',
    elementClass: WuiAlertElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDismiss: 'dismiss' },
    defineCustomElement: defineWuiAlert
});
export const WuiAutocomplete = /*@__PURE__*/ createComponent({
    tagName: 'wui-autocomplete',
    elementClass: WuiAutocompleteElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChoose: 'choose' },
    defineCustomElement: defineWuiAutocomplete
});
export const WuiBadge = /*@__PURE__*/ createComponent({
    tagName: 'wui-badge',
    elementClass: WuiBadgeElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiBadge
});
export const WuiBanner = /*@__PURE__*/ createComponent({
    tagName: 'wui-banner',
    elementClass: WuiBannerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDismiss: 'dismiss' },
    defineCustomElement: defineWuiBanner
});
export const WuiBox = /*@__PURE__*/ createComponent({
    tagName: 'wui-box',
    elementClass: WuiBoxElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiBox
});
export const WuiBreadcrumbs = /*@__PURE__*/ createComponent({
    tagName: 'wui-breadcrumbs',
    elementClass: WuiBreadcrumbsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiBreadcrumbs
});
export const WuiButton = /*@__PURE__*/ createComponent({
    tagName: 'wui-button',
    elementClass: WuiButtonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiButton
});
export const WuiCheckInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-check-input',
    elementClass: WuiCheckInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiCheckInput
});
export const WuiCheckInputGroup = /*@__PURE__*/ createComponent({
    tagName: 'wui-check-input-group',
    elementClass: WuiCheckInputGroupElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiCheckInputGroup
});
export const WuiCheckInputPanel = /*@__PURE__*/ createComponent({
    tagName: 'wui-check-input-panel',
    elementClass: WuiCheckInputPanelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiCheckInputPanel
});
export const WuiCheckListInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-check-list-input',
    elementClass: WuiCheckListInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiCheckListInput
});
export const WuiCloseButton = /*@__PURE__*/ createComponent({
    tagName: 'wui-close-button',
    elementClass: WuiCloseButtonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiCloseButton
});
export const WuiCodeEditor = /*@__PURE__*/ createComponent({
    tagName: 'wui-code-editor',
    elementClass: WuiCodeEditorElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiCodeEditor
});
export const WuiCodeSnippet = /*@__PURE__*/ createComponent({
    tagName: 'wui-code-snippet',
    elementClass: WuiCodeSnippetElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiCodeSnippet
});
export const WuiColorInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-color-input',
    elementClass: WuiColorInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiColorInput
});
export const WuiColumn = /*@__PURE__*/ createComponent({
    tagName: 'wui-column',
    elementClass: WuiColumnElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiColumn
});
export const WuiColumns = /*@__PURE__*/ createComponent({
    tagName: 'wui-columns',
    elementClass: WuiColumnsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiColumns
});
export const WuiComponentFooter = /*@__PURE__*/ createComponent({
    tagName: 'wui-component-footer',
    elementClass: WuiComponentFooterElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiComponentFooter
});
export const WuiComponentHeader = /*@__PURE__*/ createComponent({
    tagName: 'wui-component-header',
    elementClass: WuiComponentHeaderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiComponentHeader
});
export const WuiDateInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-date-input',
    elementClass: WuiDateInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported',
        onClearRangeStartDate: 'clearRangeStartDate',
        onClearRangeEndDate: 'clearRangeEndDate'
    },
    defineCustomElement: defineWuiDateInput
});
export const WuiDateInputCalendar = /*@__PURE__*/ createComponent({
    tagName: 'wui-date-input-calendar',
    elementClass: WuiDateInputCalendarElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onClearRangeStartDate: 'clearRangeStartDate',
        onClearRangeEndDate: 'clearRangeEndDate'
    },
    defineCustomElement: defineWuiDateInputCalendar
});
export const WuiDateRangeInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-date-range-input',
    elementClass: WuiDateRangeInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiDateRangeInput
});
export const WuiDateRangeInputWithPresets = /*@__PURE__*/ createComponent({
    tagName: 'wui-date-range-input-with-presets',
    elementClass: WuiDateRangeInputWithPresetsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiDateRangeInputWithPresets
});
export const WuiDatetimeReadonly = /*@__PURE__*/ createComponent({
    tagName: 'wui-datetime-readonly',
    elementClass: WuiDatetimeReadonlyElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiDatetimeReadonly
});
export const WuiDivider = /*@__PURE__*/ createComponent({
    tagName: 'wui-divider',
    elementClass: WuiDividerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiDivider
});
export const WuiDraggableList = /*@__PURE__*/ createComponent({
    tagName: 'wui-draggable-list',
    elementClass: WuiDraggableListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSort: 'sort' },
    defineCustomElement: defineWuiDraggableList
});
export const WuiDraggableListItem = /*@__PURE__*/ createComponent({
    tagName: 'wui-draggable-list-item',
    elementClass: WuiDraggableListItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiDraggableListItem
});
export const WuiDurationInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-duration-input',
    elementClass: WuiDurationInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiDurationInput
});
export const WuiEmptyState = /*@__PURE__*/ createComponent({
    tagName: 'wui-empty-state',
    elementClass: WuiEmptyStateElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiEmptyState
});
export const WuiExpandableTile = /*@__PURE__*/ createComponent({
    tagName: 'wui-expandable-tile',
    elementClass: WuiExpandableTileElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onExpandedChange: 'expandedChange' },
    defineCustomElement: defineWuiExpandableTile
});
export const WuiExpandableToggle = /*@__PURE__*/ createComponent({
    tagName: 'wui-expandable-toggle',
    elementClass: WuiExpandableToggleElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiExpandableToggle
});
export const WuiFont = /*@__PURE__*/ createComponent({
    tagName: 'wui-font',
    elementClass: WuiFontElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiFont
});
export const WuiFormField = /*@__PURE__*/ createComponent({
    tagName: 'wui-form-field',
    elementClass: WuiFormFieldElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiFormField
});
export const WuiGraphIcon = /*@__PURE__*/ createComponent({
    tagName: 'wui-graph-icon',
    elementClass: WuiGraphIconElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiGraphIcon
});
export const WuiHyperlink = /*@__PURE__*/ createComponent({
    tagName: 'wui-hyperlink',
    elementClass: WuiHyperlinkElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiHyperlink
});
export const WuiIcon = /*@__PURE__*/ createComponent({
    tagName: 'wui-icon',
    elementClass: WuiIconElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiIcon
});
export const WuiInfobox = /*@__PURE__*/ createComponent({
    tagName: 'wui-infobox',
    elementClass: WuiInfoboxElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDismiss: 'dismiss' },
    defineCustomElement: defineWuiInfobox
});
export const WuiInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-input',
    elementClass: WuiInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported',
        onChoose: 'choose'
    },
    defineCustomElement: defineWuiInput
});
export const WuiInputButton = /*@__PURE__*/ createComponent({
    tagName: 'wui-input-button',
    elementClass: WuiInputButtonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onClear: 'clear' },
    defineCustomElement: defineWuiInputButton
});
export const WuiInputMenu = /*@__PURE__*/ createComponent({
    tagName: 'wui-input-menu',
    elementClass: WuiInputMenuElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onClear: 'clear',
        onOpenChanged: 'openChanged'
    },
    defineCustomElement: defineWuiInputMenu
});
export const WuiJwPlayerBase = /*@__PURE__*/ createComponent({
    tagName: 'wui-jw-player-base',
    elementClass: WuiJwPlayerBaseElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onPlayerInstantiate: 'playerInstantiate',
        onPlayerSetup: 'playerSetup',
        onPlayerError: 'playerError',
        onPlayerReady: 'playerReady'
    },
    defineCustomElement: defineWuiJwPlayerBase
});
export const WuiJwPlayerBaseInjector = /*@__PURE__*/ createComponent({
    tagName: 'wui-jw-player-base-injector',
    elementClass: WuiJwPlayerBaseInjectorElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiJwPlayerBaseInjector
});
export const WuiJwPlayerBaseInjectorContainer = /*@__PURE__*/ createComponent({
    tagName: 'wui-jw-player-base-injector-container',
    elementClass: WuiJwPlayerBaseInjectorContainerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onPlayerInstantiate: 'playerInstantiate',
        onPlayerSetup: 'playerSetup',
        onPlayerReady: 'playerReady',
        onPlayerError: 'playerError'
    },
    defineCustomElement: defineWuiJwPlayerBaseInjectorContainer
});
export const WuiJwPlayerBaseOverlay = /*@__PURE__*/ createComponent({
    tagName: 'wui-jw-player-base-overlay',
    elementClass: WuiJwPlayerBaseOverlayElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiJwPlayerBaseOverlay
});
export const WuiLayout = /*@__PURE__*/ createComponent({
    tagName: 'wui-layout',
    elementClass: WuiLayoutElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiLayout
});
export const WuiList = /*@__PURE__*/ createComponent({
    tagName: 'wui-list',
    elementClass: WuiListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onActiveItemIndexChange: 'activeItemIndexChange' },
    defineCustomElement: defineWuiList
});
export const WuiListItem = /*@__PURE__*/ createComponent({
    tagName: 'wui-list-item',
    elementClass: WuiListItemElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiListItem
});
export const WuiListItemDivider = /*@__PURE__*/ createComponent({
    tagName: 'wui-list-item-divider',
    elementClass: WuiListItemDividerElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiListItemDivider
});
export const WuiListItemHeader = /*@__PURE__*/ createComponent({
    tagName: 'wui-list-item-header',
    elementClass: WuiListItemHeaderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiListItemHeader
});
export const WuiListItemMeta = /*@__PURE__*/ createComponent({
    tagName: 'wui-list-item-meta',
    elementClass: WuiListItemMetaElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiListItemMeta
});
export const WuiLoader = /*@__PURE__*/ createComponent({
    tagName: 'wui-loader',
    elementClass: WuiLoaderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiLoader
});
export const WuiLogo = /*@__PURE__*/ createComponent({
    tagName: 'wui-logo',
    elementClass: WuiLogoElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiLogo
});
export const WuiMainNav = /*@__PURE__*/ createComponent({
    tagName: 'wui-main-nav',
    elementClass: WuiMainNavElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onCollapseChanged: 'collapseChanged' },
    defineCustomElement: defineWuiMainNav
});
export const WuiMenuPane = /*@__PURE__*/ createComponent({
    tagName: 'wui-menu-pane',
    elementClass: WuiMenuPaneElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onClickOutside: 'clickOutside',
        onOpenChanged: 'openChanged'
    },
    defineCustomElement: defineWuiMenuPane
});
export const WuiModal = /*@__PURE__*/ createComponent({
    tagName: 'wui-modal',
    elementClass: WuiModalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDisplayChanged: 'displayChanged' },
    defineCustomElement: defineWuiModal
});
export const WuiMoreMenu = /*@__PURE__*/ createComponent({
    tagName: 'wui-more-menu',
    elementClass: WuiMoreMenuElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onOpenChanged: 'openChanged' },
    defineCustomElement: defineWuiMoreMenu
});
export const WuiMultiSelectInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-multi-select-input',
    elementClass: WuiMultiSelectInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiMultiSelectInput
});
export const WuiPageContent = /*@__PURE__*/ createComponent({
    tagName: 'wui-page-content',
    elementClass: WuiPageContentElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiPageContent
});
export const WuiPageHeader = /*@__PURE__*/ createComponent({
    tagName: 'wui-page-header',
    elementClass: WuiPageHeaderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiPageHeader
});
export const WuiPagination = /*@__PURE__*/ createComponent({
    tagName: 'wui-pagination',
    elementClass: WuiPaginationElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onChangePageLength: 'changePageLength',
        onChangePage: 'changePage'
    },
    defineCustomElement: defineWuiPagination
});
export const WuiPersistentModal = /*@__PURE__*/ createComponent({
    tagName: 'wui-persistent-modal',
    elementClass: WuiPersistentModalElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDisplayChanged: 'displayChanged' },
    defineCustomElement: defineWuiPersistentModal
});
export const WuiProgressBar = /*@__PURE__*/ createComponent({
    tagName: 'wui-progress-bar',
    elementClass: WuiProgressBarElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiProgressBar
});
export const WuiProvider = /*@__PURE__*/ createComponent({
    tagName: 'wui-provider',
    elementClass: WuiProviderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiProvider
});
export const WuiRadioButton = /*@__PURE__*/ createComponent({
    tagName: 'wui-radio-button',
    elementClass: WuiRadioButtonElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiRadioButton
});
export const WuiRadioGroup = /*@__PURE__*/ createComponent({
    tagName: 'wui-radio-group',
    elementClass: WuiRadioGroupElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiRadioGroup
});
export const WuiScrollIndicator = /*@__PURE__*/ createComponent({
    tagName: 'wui-scroll-indicator',
    elementClass: WuiScrollIndicatorElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiScrollIndicator
});
export const WuiSearchInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-search-input',
    elementClass: WuiSearchInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChoose: 'choose' },
    defineCustomElement: defineWuiSearchInput
});
export const WuiSelectInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-select-input',
    elementClass: WuiSelectInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiSelectInput
});
export const WuiSkeletonLine = /*@__PURE__*/ createComponent({
    tagName: 'wui-skeleton-line',
    elementClass: WuiSkeletonLineElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiSkeletonLine
});
export const WuiSlideOut = /*@__PURE__*/ createComponent({
    tagName: 'wui-slide-out',
    elementClass: WuiSlideOutElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDisplayChanged: 'displayChanged' },
    defineCustomElement: defineWuiSlideOut
});
export const WuiSortInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-sort-input',
    elementClass: WuiSortInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiSortInput
});
export const WuiStatus = /*@__PURE__*/ createComponent({
    tagName: 'wui-status',
    elementClass: WuiStatusElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiStatus
});
export const WuiTab = /*@__PURE__*/ createComponent({
    tagName: 'wui-tab',
    elementClass: WuiTabElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onActivate: 'activate' },
    defineCustomElement: defineWuiTab
});
export const WuiTable = /*@__PURE__*/ createComponent({
    tagName: 'wui-table',
    elementClass: WuiTableElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onSortChanged: 'sortChanged',
        onPageChanged: 'pageChanged',
        onPageLengthChanged: 'pageLengthChanged',
        onSelectedKeysChanged: 'selectedKeysChanged',
        onTableDataSourceChanged: 'tableDataSourceChanged'
    },
    defineCustomElement: defineWuiTable
});
export const WuiTableHeader = /*@__PURE__*/ createComponent({
    tagName: 'wui-table-header',
    elementClass: WuiTableHeaderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onChangeSearchQuery: 'changeSearchQuery',
        onChangeVisibleColumns: 'changeVisibleColumns',
        onChangeDensity: 'changeDensity'
    },
    defineCustomElement: defineWuiTableHeader
});
export const WuiTableHeaderRow = /*@__PURE__*/ createComponent({
    tagName: 'wui-table-header-row',
    elementClass: WuiTableHeaderRowElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onSort: 'sort',
        onSelectAllRows: 'selectAllRows',
        onDisableAll: 'disableAll'
    },
    defineCustomElement: defineWuiTableHeaderRow
});
export const WuiTablePageLengthInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-table-page-length-input',
    elementClass: WuiTablePageLengthInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChangePageLength: 'changePageLength' },
    defineCustomElement: defineWuiTablePageLengthInput
});
export const WuiTablePageNumberInput = /*@__PURE__*/ createComponent({
    tagName: 'wui-table-page-number-input',
    elementClass: WuiTablePageNumberInputElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onChangePage: 'changePage' },
    defineCustomElement: defineWuiTablePageNumberInput
});
export const WuiTableRow = /*@__PURE__*/ createComponent({
    tagName: 'wui-table-row',
    elementClass: WuiTableRowElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelectRecord: 'selectRecord' },
    defineCustomElement: defineWuiTableRow
});
export const WuiTabs = /*@__PURE__*/ createComponent({
    tagName: 'wui-tabs',
    elementClass: WuiTabsElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelectTab: 'selectTab' },
    defineCustomElement: defineWuiTabs
});
export const WuiTag = /*@__PURE__*/ createComponent({
    tagName: 'wui-tag',
    elementClass: WuiTagElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiTag
});
export const WuiTagList = /*@__PURE__*/ createComponent({
    tagName: 'wui-tag-list',
    elementClass: WuiTagListElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiTagList
});
export const WuiTextarea = /*@__PURE__*/ createComponent({
    tagName: 'wui-textarea',
    elementClass: WuiTextareaElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiTextarea
});
export const WuiThemeSection = /*@__PURE__*/ createComponent({
    tagName: 'wui-theme-section',
    elementClass: WuiThemeSectionElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiThemeSection
});
export const WuiThumbnail = /*@__PURE__*/ createComponent({
    tagName: 'wui-thumbnail',
    elementClass: WuiThumbnailElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiThumbnail
});
export const WuiThumbnailGrid = /*@__PURE__*/ createComponent({
    tagName: 'wui-thumbnail-grid',
    elementClass: WuiThumbnailGridElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onDelete: 'delete',
        onEdit: 'edit'
    },
    defineCustomElement: defineWuiThumbnailGrid
});
export const WuiTile = /*@__PURE__*/ createComponent({
    tagName: 'wui-tile',
    elementClass: WuiTileElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiTile
});
export const WuiTileTabbedHeader = /*@__PURE__*/ createComponent({
    tagName: 'wui-tile-tabbed-header',
    elementClass: WuiTileTabbedHeaderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onSelectTab: 'selectTab' },
    defineCustomElement: defineWuiTileTabbedHeader
});
export const WuiTileTextHeader = /*@__PURE__*/ createComponent({
    tagName: 'wui-tile-text-header',
    elementClass: WuiTileTextHeaderElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiTileTextHeader
});
export const WuiToast = /*@__PURE__*/ createComponent({
    tagName: 'wui-toast',
    elementClass: WuiToastElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onDisplayChanged: 'displayChanged' },
    defineCustomElement: defineWuiToast
});
export const WuiToggle = /*@__PURE__*/ createComponent({
    tagName: 'wui-toggle',
    elementClass: WuiToggleElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {
        onValidityChecked: 'validityChecked',
        onValidityReported: 'validityReported'
    },
    defineCustomElement: defineWuiToggle
});
export const WuiTooltip = /*@__PURE__*/ createComponent({
    tagName: 'wui-tooltip',
    elementClass: WuiTooltipElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiTooltip
});
export const WuiTooltipLabel = /*@__PURE__*/ createComponent({
    tagName: 'wui-tooltip-label',
    elementClass: WuiTooltipLabelElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: {},
    defineCustomElement: defineWuiTooltipLabel
});
export const WuiTopNav = /*@__PURE__*/ createComponent({
    tagName: 'wui-top-nav',
    elementClass: WuiTopNavElement,
    // @ts-ignore - ignore potential React type mismatches between the Stencil Output Target and your project.
    react: React,
    events: { onMenuOpenChanged: 'menuOpenChanged' },
    defineCustomElement: defineWuiTopNav
});
